import { Component, OnInit } from '@angular/core';
import { AccountInfo } from '../../models/account-info';
import { AccountInfoService } from '../../services/account-info.service';
import { AccountInfoDataSource } from './account-info.datasource';
import { BasePagedDataSource } from '../../../../base/table/paged-table-base.datasource';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css']
})
export class AccountListComponent implements OnInit {

  dataSource : BasePagedDataSource<AccountInfo> = new BasePagedDataSource<AccountInfo>(this.AccountInfoService);
  displayedColumns = ['actions','name'];

  constructor(
    public userService:UserService,
    private router: Router,
    private AccountInfoService:AccountInfoService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.dataSource.loadData();
  }
  OnEdit(model:AccountInfo){
    if(this.userService.hasRole('Admin')){
      this.router.navigate(["/administration/accounts/edit",model.id]);
    }    
  }
  OnAdd(){
    this.router.navigate(["/administration/accounts/add"]);
  }  
}
